import HorusIcon from "../images/HorusIcon.mjs";

/**
 * App logo
 */
const AppMainIcon = class extends HorusIcon {}

export default AppMainIcon;
